
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import {
  HomeIcon,
  CogIcon,
  DocumentTextIcon,
  UserGroupIcon,
  BriefcaseIcon,
  ChartBarIcon,
  ArrowLeftIcon,
  GlobeAltIcon
} from '@heroicons/react/24/outline'

export default function AdminSidebar() {
  const location = useLocation()
  const { logout } = useAuth()
  // Navegación fija para el panel admin
  const navigation = [
    { name: 'Dashboard', href: '/admin', icon: HomeIcon },
    { name: 'Servicios', href: '/admin/servicios', icon: BriefcaseIcon },
    { name: 'Casos', href: '/admin/casos', icon: ChartBarIcon },
    { name: 'Blog', href: '/admin/blog', icon: DocumentTextIcon },
    { name: 'Equipo', href: '/admin/equipo', icon: UserGroupIcon },
    { name: 'Ajustes', href: '/admin/ajustes', icon: CogIcon },
  ]

  return (
    <div className="w-64 bg-glass border-r border-primary/20 p-6">
      <div className="flex items-center space-x-2 mb-8">
        <div className="w-8 h-8 bg-gradient-to-r from-primary to-secondary rounded-lg flex items-center justify-center">
          <span className="text-dark font-bold text-sm">RS</span>
        </div>
        <span className="text-lg font-bold text-gradient">Admin Panel</span>
      </div>

      <nav className="space-y-2">
        {navigation.map((item) => {
          const isActive = location.pathname === item.href
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-primary/20 text-primary border border-primary/30'
                  : 'text-gray-300 hover:bg-primary/10 hover:text-primary'
              }`}
            >
              <item.icon className="h-5 w-5" />
              <span>{item.name}</span>
            </Link>
          )
        })}
      </nav>

      <div className="mt-8 pt-6 border-t border-primary/20">
        <Link
          to="/"
          className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-primary hover:bg-primary/10 rounded-lg transition-all duration-200 group mb-4"
        >
          <ArrowLeftIcon className="h-4 w-4 group-hover:text-primary" />
          <GlobeAltIcon className="h-4 w-4 group-hover:text-primary" />
          <span className="text-sm">Ir al Sitio Web</span>
        </Link>

        <button
          onClick={logout}
          className="w-full flex items-center justify-center space-x-2 px-4 py-3 text-gray-300 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors"
        >
          <span>Cerrar Sesión</span>
        </button>
      </div>
    </div>
  )
}
